import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import FeaturedCategories from './components/FeaturedCategories';
import FeaturedArticles from './components/FeaturedArticles';
import NewsletterSection from './components/NewsletterSection';

const pageSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '夜无疆 - 首页',
    description: '夜无疆是打破黑夜边界的极致体验平台。探索夜间生活、创作灵感、深夜情绪，加入夜行者社群。',
    url: 'https://wwyjs.cn/',
  },
];

export default function Home() {
  return (
    <>
      <SEOHead
        title="夜无疆 - 打破黑夜边界的极致体验"
        description="「夜无疆」是一个关于夜晚无限可能的探索平台。无论是夜间生活、创作灵感还是深夜情绪，夜无疆陪你穿越每一个漫长黑夜，让夜晚不再有边界，感受属于夜的自由与力量。"
        keywords="夜无疆,夜无疆体验,夜间无限探索,深夜自由生活,夜晚边界突破,黑夜创作灵感,夜行者社群"
        canonicalUrl="/"
        schema={pageSchema}
      />
      <main>
        <HeroSection />
        <StatsSection />
        <FeaturedCategories />
        <FeaturedArticles />
        <NewsletterSection />
      </main>
    </>
  );
}